import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONTENT_TYPE, ContentType } from '../../types/types';

export const emptyOption = 'Kaikki sisältötyypit';
export const includeNewsOption = 'Hae myös uutissisällöistä';
// eslint-disable-next-line react-refresh/only-export-components
export const articleContentTypes = [
  { name: 'Artikkelit', type: CONTENT_TYPE.Article },
  { name: 'Katsaukset', type: CONTENT_TYPE.Overview },
  { name: 'Juridiikkaa lyhyesti', type: CONTENT_TYPE.ShortLegalNews },
  { name: 'Oikeustapauskommentit', type: CONTENT_TYPE.CaseCommentary },
  { name: 'Uutiset', type: CONTENT_TYPE.LegalNews },
];

export default function ContentTypeSelect({
  value,
  onChange,
  size = 'medium',
  helperText,
}: {
  readonly value: ContentType[];
  readonly onChange: (value: ContentType[]) => void;
  readonly size?: 'small' | 'medium';
  readonly helperText?: string;
}) {
  const { t } = useTranslation();
  return (
    <Autocomplete
      multiple
      options={articleContentTypes}
      getOptionLabel={(option) => option.name}
      value={articleContentTypes.filter((opt) => value.includes(opt.type))}
      onChange={(_, newValue) =>
        onChange(newValue.map((opt) => opt.type as ContentType))
      }
      disableCloseOnSelect
      fullWidth
      autoHighlight
      popupIcon={null}
      renderInput={(params) => (
        <TextField
          {...params}
          variant='outlined'
          label={t('search.filterLabel')}
          placeholder={t('search.filterPlaceholder')}
          size={size}
          fullWidth
          helperText={helperText ?? t('search.filterHelperText')}
          sx={{
            minWidth: 0,
            '& .MuiInputBase-root': {
              boxSizing: 'border-box',
              backgroundColor: 'background.paper',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiAutocomplete-tag': {
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              marginRight: 0.5,
            },
            '& .MuiAutocomplete-inputRoot': {
              flexWrap: 'nowrap',
            },
          }}
        />
      )}
      sx={{
        minWidth: 0,
        width: '100%',
        '& .MuiAutocomplete-inputRoot': {
          flexWrap: 'nowrap',
        },
        '& .MuiAutocomplete-tag': {
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    />
  );
}
